import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_target",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light" }, "Implementation Progress Report")
  ])
], -1)
const _hoisted_3 = {
  id: "entity_target",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date", -1)
const _hoisted_15 = { class: "col-md-2 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = { class: "card mb-5 mb-xl-10" }
const _hoisted_18 = {
  id: "entity_target_list",
  class: "collapse show"
}
const _hoisted_19 = { class: "collapse show" }
const _hoisted_20 = { class: "card-body border-top p-0" }
const _hoisted_21 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("h3", null, "Implementation Progress Report")
      ])
    ])
  ])
], -1)
const _hoisted_23 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_24 = { class: "collapse show" }
const _hoisted_25 = { class: "card-body border-top p-6" }
const _hoisted_26 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_27 = { class: "row w-100 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_29 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "table-responsive" }
const _hoisted_37 = { class: "table table-borderless gy-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
  /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important"} }, " SEIP Outputs "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid #50cd89 !important"},
    class: "text-center",
    colspan: "4"
  }, " Quarterly "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid #50cd89 !important"},
    class: "text-center",
    colspan: "4"
  }, " Cumulative ")
], -1)
const _hoisted_39 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_40 = { style: {"border":"1px solid #50cd89 !important","padding-left":"10px"} }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { style: {"border":"1px solid #50cd89 !important","text-align":"left","padding-right":"10px"} }
const _hoisted_43 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_44 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_45 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_49 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_50 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_51 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_55 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_56 = {
  colspan: "10",
  style: {"border":"1px solid #50cd89 !important","padding-left":"10px"}
}
const _hoisted_57 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"left","padding-right":"10px"} }
const _hoisted_58 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_59 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_60 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_64 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_65 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_66 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { style: {"border":"1px solid\r\n                                                          #50cd89 !important","text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_form_item, {
                  prop: "start_date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.start_date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.start_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      style: {"width":"100%"},
                      type: "date",
                      name: "satrt"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_form_item, {
                  prop: "end_date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.end_date,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.end_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      style: {"width":"100%"},
                      type: "date",
                      name: "satrt"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getProgressData())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_16
                ])
              ])
            ]),
            (_ctx.showinstitutionList)
              ? (_openBlock(), _createElementBlock("div", {
                  key: _ctx.componentKey,
                  class: "mt-7"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", null, [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                          _hoisted_28,
                                          _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                              title: "Download Xlse",
                                              "data-v-54b12dc8": "",
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                                            }, _hoisted_31),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                              title: "Download PDF",
                                              "data-v-54b12dc8": "",
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                                            }, _hoisted_33),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                              title: "Print",
                                              "data-v-54b12dc8": "",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                                            }, _hoisted_35)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("table", _hoisted_37, [
                                            _createElementVNode("thead", null, [
                                              _hoisted_38,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressData, (data, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                  _createElementVNode("tr", _hoisted_39, [
                                                    _createElementVNode("th", _hoisted_40, _toDisplayString(data?.seip_output), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data?.header, (header, hinx) => {
                                                      return (_openBlock(), _createElementBlock("th", {
                                                        key: hinx,
                                                        style: {"border":"1px solid #50cd89 !important","text-align":"center"}
                                                      }, _toDisplayString(header), 1))
                                                    }), 128))
                                                  ]),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data?.association_type, (type, tinx) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: tinx }, [
                                                      (data?.seip_output ==
                                                'III. Job Placement'
                                                )
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                                                            _createElementVNode("td", _hoisted_42, _toDisplayString(type?.type_header), 1),
                                                            _createElementVNode("td", _hoisted_43, _toDisplayString(type?.row_data?.q_target), 1),
                                                            _createElementVNode("td", _hoisted_44, _toDisplayString(type?.row_data?.q_actual), 1),
                                                            _createElementVNode("td", _hoisted_45, [
                                                              _createTextVNode(_toDisplayString(type?.row_data?.q_female) + " (", 1),
                                                              (type?.row_data
                                                          ?.q_female > 0
                                                        )
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString((
                                                          (type?.row_data
                                                            ?.q_female /
                                                            type?.row_data
                                                              ?.q_actual) *
                                                          100
                                                        ).toFixed(2)), 1))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_47, "0.00")),
                                                              _createTextVNode("%) ")
                                                            ]),
                                                            _createElementVNode("td", _hoisted_48, _toDisplayString(type?.row_data?.q_achieved), 1),
                                                            _createElementVNode("td", _hoisted_49, _toDisplayString(type?.row_data?.c_target), 1),
                                                            _createElementVNode("td", _hoisted_50, _toDisplayString(type?.row_data?.c_actual), 1),
                                                            _createElementVNode("td", _hoisted_51, [
                                                              _createTextVNode(_toDisplayString(type?.row_data?.c_female) + " (", 1),
                                                              (type?.row_data
                                                          ?.c_female > 0
                                                        )
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString((
                                                          (type?.row_data
                                                            ?.c_female /
                                                            type?.row_data
                                                              ?.c_actual) *
                                                          100
                                                        ).toFixed(2)), 1))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_53, "0.00")),
                                                              _createTextVNode("%) ")
                                                            ]),
                                                            _createElementVNode("td", _hoisted_54, _toDisplayString(type?.row_data?.c_achieved), 1)
                                                          ]))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createElementVNode("tr", _hoisted_55, [
                                                              _createElementVNode("th", _hoisted_56, _toDisplayString(type?.type_header), 1)
                                                            ]),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type?.row_data, (value, vnx) => {
                                                              return (_openBlock(), _createElementBlock("tr", { key: vnx }, [
                                                                _createElementVNode("td", _hoisted_57, _toDisplayString(value?.header), 1),
                                                                _createElementVNode("td", _hoisted_58, _toDisplayString(value?.q_target), 1),
                                                                _createElementVNode("td", _hoisted_59, _toDisplayString(value?.q_actual), 1),
                                                                _createElementVNode("td", _hoisted_60, [
                                                                  _createTextVNode(_toDisplayString(value?.q_female) + " (", 1),
                                                                  (value?.q_female > 0
                                                        )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString((
                                                            (value?.q_female /
                                                              value?.q_actual) *
                                                            100
                                                          ).toFixed(2)), 1))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_62, "0.00")),
                                                                  _createTextVNode("%) ")
                                                                ]),
                                                                _createElementVNode("td", _hoisted_63, _toDisplayString(value?.q_achieved), 1),
                                                                _createElementVNode("td", _hoisted_64, _toDisplayString(value?.c_target), 1),
                                                                _createElementVNode("td", _hoisted_65, _toDisplayString(value?.c_actual), 1),
                                                                _createElementVNode("td", _hoisted_66, [
                                                                  _createTextVNode(_toDisplayString(value?.c_female) + " (", 1),
                                                                  (value?.c_female > 0
                                                        )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString((
                                                            (value?.c_female /
                                                              value?.c_actual) *
                                                            100
                                                          ).toFixed(2)), 1))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_68, "0.00")),
                                                                  _createTextVNode("%) ")
                                                                ]),
                                                                _createElementVNode("td", _hoisted_69, _toDisplayString(value?.c_achieved), 1)
                                                              ]))
                                                            }), 128))
                                                          ], 64))
                                                    ], 64))
                                                  }), 128))
                                                ], 64))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}